<ngb-alert [hidden]="!show" [type]="'danger'" [dismissible]="false">
  <ng-container *ngIf="user.admin">
    Your account has reached a usage cap for errors. Adjust usage caps on your
    <a class="alert-link" href="/account/edit#tab-usage-caps" target="_self">
      account settings</a
    >
    to accept additional errors in this billing cycle.
  </ng-container>

  <ng-container *ngIf="!user.admin">
    Your account has reached a usage cap for errors. Please contact your account
    admin to adjust usage caps to accept additional errors in this billing
    cycle.
  </ng-container>
</ngb-alert>
